export const repeatStrategyOptions = ['none', 'playlist', 'track'];
export const MEDIA_ERR_NETWORK = 2;
